import React from 'react';

import { Checkbox } from 'ui-components/components/checkbox';

import '../prop-types/alert.types';
import { AlertDescription } from './alert-description';
import { AlertType } from './alert-type';
import style from './style.module.less';

/**
 * @param {object} props
 * @param {AlertPropType} props.alert
 * @param {boolean} props.isSelected
 * @param {(alertId: string) => void} props.onChange
 * @param {() => void} props.closeModal
 * @returns {JSX.Element}
 */
export const AlertRow = ({ alert, isSelected, onChange, closeModal }) => {
  return (
    <div className={style['alert-row']}>
      <div className={style['alert-row-selector']}>
        <Checkbox checked={isSelected} onChange={() => onChange(alert.alertID)} />
      </div>
      <AlertType alertType={alert.alertType} />
      <AlertDescription alert={alert} closeModal={closeModal} />
    </div>
  );
};
